module.exports = __webpack_public_path__ + "static/img/service12.5f8805c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg/service12.png
// module id = oOc6
// module chunks = 1 2